export default __webpack_public_path__ + "static/22-04a6dc6eceea857ae0d633e7857ec3a2.webp";